<template>
    <ul class="collection_ul">
        <!--          v-for="galleryList in galleryLists" key="`${galleryList}`"-->
        <li class="colelction_li" v-for="(gallery, index) in galleryData" :key="`gallery${gallery.c_idx}`">
            <div class="thumbnail">
                <img :src="returnImage(gallery)"
                     class="c_img" alt="" @click="movePage(`/gallery/${gallery.c_idx}/edit`)">
                <button class="setting" @click="openEditModal(gallery.c_idx)"></button>
            </div>
            <div class="collection_subject pl5 " @click="movePage(`/gallery/${gallery.c_idx}/edit`)">{{ gallery.c_title }}</div>
        </li>
    </ul>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util";

export default {
    name: "GalleryListDefaultLayout",
    mixins: [imageOption],
    components: {},
    inject: [],
    provide() {
        return{

        }
    },
    props: {
        galleryData: {default: () => []},
        paginationData: {default: {page: 1, size: 10, total: 0}}
    },
    data() {
        return{
            collectionLists: 3,
        }
    },
    beforeRouterEnter() {},
    created() {
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{
        movePage(url) {
            this.$router.push(url);
        },
        openEditModal(key) {
            this.$modal.show('gallery-setting-modal', {galleryKey: key});
        },
        returnImage(gallery) {
            if(util.isEmpty(gallery) || util.isEmpty(gallery.Files) || util.isEmpty(gallery.Files.Background)) {
                return "";
            }
            return `${gallery.Files.Background[0].org_url}?${this.setImageOptions(378, 240, 'jpg')}`;
        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
